import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import ReactDOM from 'react-dom';
import UserProfileComponent from './UserProfileComponent';
import { userData } from './data';


var createFirstLoginDom = function createFirstLoginDom() {
  var div = document.createElement('div');
  document.body.appendChild(div);
  return {
    initial: function initial(props) {
      if (props.initialData) {
        var _props$initialData = props.initialData,
            languageRegion = _props$initialData.languageRegion,
            profileInfo = _props$initialData.profileInfo,
            addressInfo = _props$initialData.addressInfo,
            userImg = _props$initialData.userImg,
            staticSource = _props$initialData.staticSource;
        userData.languageRegion = languageRegion || {};
        userData.profileInfo = profileInfo || {};
        userData.addressInfo = addressInfo || [];
        userData.userImg = userImg || '';
        userData.staticSource = _objectSpread(_objectSpread({}, userData.staticSource), staticSource) || {};
      }

      ReactDOM.render( /*#__PURE__*/React.createElement(UserProfileComponent, props), div);
    },
    destroy: function destroy() {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    }
  };
};

var userProfileObj = null;

var userProfileFun = function userProfileFun(options, callback) {
  if (userProfileObj) {
    userProfileObj.destroy();
  }

  userProfileObj = createFirstLoginDom();

  var onCloseWrap = function onCloseWrap() {
    if (userProfileObj) userProfileObj.destroy();
    userProfileObj = null;

    if (callback) {
      callback();
    }
  };

  var optionsExtend = _objectSpread(_objectSpread({}, options), {}, {
    onCloseWrap: onCloseWrap
  });

  userProfileObj.initial(optionsExtend);
};

var UserProfile = {
  show: function show(options, onCloseCallback) {
    if (onCloseCallback) {
      return userProfileFun(options, onCloseCallback);
    } else {
      return userProfileFun(options);
    }
  },
  getProfile: function getProfile() {
    return userData;
  }
};
export default UserProfile;